// Initialize Sentry FIRST, before any other code runs
import { initSentry } from './lib/sentry'
initSentry()

import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx'
import { authStore } from './stores/auth.store'
import { ErrorBoundary } from './components/ErrorBoundary'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './styles.css'

// Create a new router instance

const TanStackQueryProviderContext = TanStackQueryProvider.getContext()
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProviderContext,
    auth: authStore,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Auto-reload when a JS chunk fails to load (e.g. after a new deployment)
window.addEventListener('vite:preloadError', () => window.location.reload())

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </TanStackQueryProvider.Provider>
    </StrictMode>,
  )
}

